import * as React from 'react';
import {stylesheet} from 'typestyle';
import GeneralSelectorTableStore from '../../stores/GeneralSelectorTableStore';
import {TProvider} from '../../i18n/i18n';
import {observer} from 'mobx-react';
import {LightGreyColor} from '../../styles/colors';

interface DelayedTableSearchFieldProps {
    onDelayedChange: (text: string) => void;
    value: string;
}

class DelayedTableSearchField extends React.Component<DelayedTableSearchFieldProps, {text: string}> {
    private idTimeout: number;

    constructor(props: DelayedTableSearchFieldProps) {
        super(props);
        this.state = {
            text: props.value,
        };
        this.idTimeout = 0;
    }

    public componentWillReceiveProps(nextProps: DelayedTableSearchFieldProps) {
        this.setState({
            text: nextProps.value,
        });
    }

    private onSearchChange(e: React.ChangeEvent<HTMLInputElement>) {
        const text = e.currentTarget.value;
        this.setState({
            text,
        });
        clearTimeout(this.idTimeout);
        this.idTimeout = window.setTimeout(() => {
            this.props.onDelayedChange(text);
        }, 750);
    }

    public render() {
        return (
            <TProvider>
                {(t) => <input type="text" placeholder={t('search')} value={this.state.text} onChange={this.onSearchChange.bind(this)} />}
            </TProvider>
        );
    }
}

interface TableSearchProps {
    selectorTableStore: GeneralSelectorTableStore;
    height: number;
}

@observer
export class TableSearch extends React.Component<TableSearchProps> {
    public render() {
        const {selectorTableStore} = this.props;
        return (
            <div className={tableSearchCss.container}>
                <DelayedTableSearchField
                    onDelayedChange={(search) => {
                        selectorTableStore.searchterm = search;
                        selectorTableStore.runSearch(search);
                    }}
                    value={selectorTableStore.searchterm}
                />
                <div className={tableSearchCss.searchIcon}>
                    <i className="fa fa-search" aria-hidden="true" />
                </div>
            </div>
        );
    }
}

const tableSearchCss = stylesheet({
    container: {
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        marginTop: 7,
        verticalAlign: 'top',
        lineHeight: 'initial',
        paddingRight: 40,
        $nest: {
            '& input': {
                borderRadius: 0,
                height: 29,
                width: '100%',
                padding: '3px 5px 3px 0',
                border: 0,
                borderBottom: '2px solid ' + LightGreyColor,
                marginLeft: 30,
                outline: 'none',
            },
        },
    },
    searchIcon: {
        position: 'absolute',
        color: LightGreyColor,
        top: 1,
        left: 10,
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/TableSearch.tsx